import { render, staticRenderFns } from "./Deactivate.vue?vue&type=template&id=6f63d910"
import script from "./Deactivate.vue?vue&type=script&lang=js"
export * from "./Deactivate.vue?vue&type=script&lang=js"
import style0 from "./Deactivate.vue?vue&type=style&index=0&id=6f63d910&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports